import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutofocusDirective } from './directives/autofocus.directive';
import { EmailValidatorDirective } from './validators/email';
import { PhoneValidatorDirective } from './validators/phone';
import { PortNumberValidatorDirective } from './validators/port-number';
import { ServerNameValidatorDirective } from './validators/server-name';
import { TrimDirective } from './directives/trim.directive';
import { UIInputComponent } from './input.component';
import { UIInputDirective } from './input.directive';
import { UIInputErrorComponent } from './error.component';
import { UISvgIconModule } from 'app/ui/svg-icon/svg-icon.module';
import {NameValidatorDirective} from "./validators/name";

@NgModule({
    imports: [
        CommonModule,
        UISvgIconModule
    ],
    declarations: [
        AutofocusDirective,
        EmailValidatorDirective,
        PhoneValidatorDirective,
        NameValidatorDirective,
        PortNumberValidatorDirective,
        ServerNameValidatorDirective,
        TrimDirective,
        UIInputComponent,
        UIInputDirective,
        UIInputErrorComponent
    ],
    exports: [
        AutofocusDirective,
        EmailValidatorDirective,
        PhoneValidatorDirective,
        NameValidatorDirective,
        PortNumberValidatorDirective,
        ServerNameValidatorDirective,
        TrimDirective,
        UIInputComponent,
        UIInputDirective,
        UIInputErrorComponent
    ]
})
export class UIInputModule {
}
